import { render, staticRenderFns } from "./my_try.vue?vue&type=template&id=4ba37598&scoped=true"
import script from "./my_try.vue?vue&type=script&lang=js"
export * from "./my_try.vue?vue&type=script&lang=js"
import style0 from "./my_try.vue?vue&type=style&index=0&id=4ba37598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba37598",
  null
  
)

export default component.exports